import { resolvePlanPrice } from './planAnnualPricing';

/** Preços SaaS da seção Automação — valores numéricos por moeda e ciclo. */

export const AUTOMATION_PLAN_PRICES = {
  start: {
    monthly: { BRL: 697, EUR: 119, USD: 149 },
    annual: { BRL: 6970, EUR: 1190, USD: 1490 }
  },
  growth: {
    monthly: { BRL: 1997, EUR: 299, USD: 349 },
    annual: { BRL: 19970, EUR: 2990, USD: 3490 }
  },
  premium: {
    monthly: { BRL: 4997, EUR: 799, USD: 999 },
    annual: { BRL: 49970, EUR: 7990, USD: 9990 },
    plus: true
  }
};

export function getDefaultAutomationCurrency(language) {
  if (language === 'pt-BR') return 'BRL';
  if (language === 'pt-PT') return 'EUR';
  return 'USD';
}

const formatterCache = new Map();

function getNumberFormatter(locale) {
  if (!formatterCache.has(locale)) {
    formatterCache.set(
      locale,
      new Intl.NumberFormat(locale, { minimumFractionDigits: 0, maximumFractionDigits: 0 })
    );
  }
  return formatterCache.get(locale);
}

export function formatAutomationPlanPrice(amount, currency, cycle, opts = {}) {
  const { plus = false, language = 'pt-BR' } = opts;
  const suffix = plus ? '+' : '';
  const isEn = language === 'en' || (language && !String(language).startsWith('pt'));
  const periodMonthly = isEn ? '/mo' : '/mês';
  const periodAnnual = isEn ? '/yr' : '/ano';
  const period = cycle === 'monthly' ? periodMonthly : periodAnnual;

  const n = getNumberFormatter(
    currency === 'BRL' ? 'pt-BR' : currency === 'EUR' ? 'pt-PT' : 'en-US'
  ).format(amount);

  if (currency === 'BRL') return `R$ ${n}${period}${suffix}`;
  if (currency === 'EUR') return `${n} €${period}${suffix}`;
  return `US$ ${n}${period}${suffix}`;
}

export function getAutomationPlanPrice(planKey, currency, cycle, language) {
  return resolvePlanPrice({
    plan: AUTOMATION_PLAN_PRICES[planKey],
    currency,
    cycle,
    language,
    formatPrice: formatAutomationPlanPrice
  });
}
